import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { isWholeThousand } from "Utils/numberUtils";
import { CaravanProductDetailsFormValues } from "./interfaces";

export const MIN_SUM_INSURED = 10000;
export const MAX_SUM_INSURED = 500000;

export const validationSchema =
  (): Yup.ObjectSchema<CaravanProductDetailsFormValues> => {
    const { getText } = TextManager;
    const invalidSumText = getText(
      "caravanform.validation.coverageamount_invalid",
      {
        variables: {
          caravan_coverageSumMin: MIN_SUM_INSURED,
          caravan_coverageSumMax: MAX_SUM_INSURED,
        },
      },
    );

    return Yup.object({
      coverageAmount: Yup.number()
        .required(getText("caravanform.validation.coverageamount_required"))
        .min(MIN_SUM_INSURED, invalidSumText)
        .max(MAX_SUM_INSURED, invalidSumText)
        .test({
          name: "is-whole-thousand",
          message: getText("caravanform.validation.coverageamount_notwhole"),
          test: isWholeThousand,
        }),
      fixedPlace: Yup.mixed<BooleanFormType>()
        .oneOf(Object.values(BooleanFormType))
        .required(getText("caravanform.validation.fixedplace")),
    }).concat(getInjuriesSchema());
  };
